import angular from 'angular';
import PasswordForgot from './passwordForgot';
import PasswordEdit from './passwordEdit';

export default angular.module('password', [
  PasswordForgot.name,
  PasswordEdit.name,
  'ui.router'
])
  .config(($stateProvider, $urlRouterProvider) => {
    $stateProvider
      .state('password', {
        abstract: true,
        url: '/password',
        template: '<ui-view/>',
        data: {
          permissions: {
            only: ['anonymous'],
            redirectTo: ''
          }
        }
      })
      .state('password.forgot', {
        url: '/forgot',
        template: '<password-forgot></password-forgot>',
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.password.forgot');
          }
        }
      })
      .state('password.edit', {
        url: '/edit?token',
        template: '<password-edit></password-edit>',
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.password.edit');
          }
        }
      })
  })



/** WEBPACK FOOTER **
 ** ./src/components/account/password/password.js
 **/